import { Component } from '@angular/core';

@Component({
    selector: 'app-thermo',
    templateUrl: './thermo.component.html',
    styleUrl: './thermo.component.scss',
    standalone: false
})
export class ThermoComponent {

}
